import { render, staticRenderFns } from "./SpecialHobby.vue?vue&type=template&id=39a1ef44&scoped=true&"
import script from "./SpecialHobby.vue?vue&type=script&lang=js&"
export * from "./SpecialHobby.vue?vue&type=script&lang=js&"
import style0 from "./SpecialHobby.vue?vue&type=style&index=0&id=39a1ef44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a1ef44",
  null
  
)

export default component.exports